export default {"src":"https://fishbrain.com/_next/static/media/illinois.f975b6dd.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};